import React, { Fragment, useContext } from "react";

import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";

import "../Assets/Css/body.css";
import "../Assets/Css/heading.css";
import AppContext from "./AppContext";
import { FactsText, WelcomeFactsText } from "./Texts.js";
import Icofont from "react-icofont";
import { Row, Col } from "react-bootstrap";

export const Facts = () => {
  const context = useContext(AppContext);
  return (
    <Fragment>
      <section className="page-section bg-primary text-white mb-0" id="facts">
        <div className="container">
          {/* About Section Heading*/}
          <div className="text-center">
            <h2 className="page-section-heading d-inline-block text-white">
              {context.lang.get === "en" ? WelcomeFactsText[0].title_DE : WelcomeFactsText[0].title_ENG}
            </h2>
          </div>
          {/* Icon Divider*/}
          <div className="divider-custom divider-light mb-5">
            <div className="divider-custom-line"></div>
            <div className="divider-custom-icon">
              <i className="fas fa-star"></i>
            </div>
            <div className="divider-custom-line"></div>
          </div>
          <Container className="mb-5">
            {/* <CardDeck style={{ marginBottom: "12px" }}> */}
            <Row>
              {FactsText.map((item, i) => (
                <Col key={i} md={6} lg={4}>
                  <Card
                    className="text-center text-white mx-auto"
                    style={{ border: "none", textAlign: "center", backgroundColor: "transparent" }}
                  >
                    <Icofont icon={item.image} style={{ fontSize: "3.3rem" }} />
                    <Card.Body>
                      <Card.Title style={{ height: "60px" }}>
                        {context.lang.get === "en" ? item.title_DE : item.title_ENG}
                      </Card.Title>
                      <Card.Text>
                        {/* <h6>{context.lang.get === "en" ? item.subtitle_DE : item.subtitle_ENG}</h6> */}
                        {context.lang.get === "en"
                          ? item.text_DE.split("\n").map((item, i) => (
                              <div className="mb-3" key={i}>
                                {item}
                              </div>
                            ))
                          : item.text_ENG.split("\n").map((item, i) => (
                              <div className="mb-3" key={i}>
                                {item}
                              </div>
                            ))}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
            {/* </CardDeck> */}
          </Container>
          {/* About Section Content*/}
          {/* <div className="row">
						<div className="col-lg-4 ml-auto">
							<p className="pre-wrap lead">
								Freelancer is a free bootstrap theme created by Start Bootstrap. The download includes the
								complete source files including HTML, CSS, and JavaScript as well as optional SASS stylesheets
								for easy customization.
							</p>
						</div>
						<div className="col-lg-4 mr-auto">
							<p className="pre-wrap lead">
								You can create your own custom avatar for the masthead, change the icon in the dividers, and
								add your email address to the contact form to make it fully functional!
							</p>
						</div>
					</div> */}
        </div>
      </section>
    </Fragment>
  );
};

export default Facts;
